import { DAPI_HOST } from '../../config';

const getConsentFormSignaturesUrl = () => `${DAPI_HOST}/v2/consent-form-signatures`;

export { getConsentFormSignaturesUrl };
